module.exports = __webpack_public_path__ + "img/48x34x96-Kit.e8c9a14d.png";